module.exports = __webpack_public_path__ + "img/宣传页2.671415c2.jpg";